import { ConversionBlock } from '@/entities/conversion'
import { Currencies } from '@/entities/curency'
import { StatisticsBanner, StatisticItem } from '@/shared/components'
import { formatCurrency } from '@/shared/lib/currency'
import { useAddToastError } from '@/shared/lib'
import { DateRange } from 'react-day-picker'
import { useEffect } from 'react'
import { useReferralData } from '@/entities/referral/hooks'
import { DatePickerWithRange } from '@/entities/datePicker'
import { useIsMobile } from '@/shared/utils'

interface ReferralStatsBannerProps {
  referralId: string
  dateRange?: DateRange
  onDateChange?: (range: DateRange | undefined) => void
}

export const ReferralStatsBanner = ({ referralId, dateRange, onDateChange }: ReferralStatsBannerProps) => {
  const addToastError = useAddToastError()
  const isMobile = useIsMobile()

  const { data: referralData, error } = useReferralData({
    referralId,
    dateRange,
  })

  useEffect(() => {
    if (error) {
      addToastError(error)
    }
  }, [error?.message])

  const referral = referralData?.items?.[0]
  const topupSummary = referral?.topupSummary
  const todayTopupSummary = referral?.todayTopupSummary

  const turnoverUdst = Number(topupSummary?.paidFactAmountTo) || 0
  const turnoverRub = Number(topupSummary?.paidFactAmountFrom) || 0
  const orders = topupSummary?.totalCount || 0
  const profit = formatCurrency(Number(referral?.referralProfit) || 0, Currencies.USDT)
  const dailyLimit = Number(todayTopupSummary?.totalFactAmountFrom) || 0
  const totalRequisitMaxDailyLimit = Number(referral?.totalRequisitMaxDailyLimit) || 0

  const items: StatisticItem[] = [
    {
      label: 'Суточный лимит',
      value: (
        <span>
          {formatCurrency(dailyLimit, Currencies.RUB)}
          <span className="text-text-secondary"> / {formatCurrency(totalRequisitMaxDailyLimit, Currencies.RUB)}</span>
        </span>
      ),
    },
    {
      label: 'Активные реквизиты',
      value: referral?.requisitCount || 0,
    },
    {
      label: 'Всего сделок',
      value: orders,
    },
    {
      label: 'Конверсия',
      value: (
        <div className="flex gap-x-1">
          <ConversionBlock current={topupSummary?.paidCount || 0} goal={orders} />
        </div>
      ),
    },
    {
      label: 'Прибыль',
      value: profit,
    },
    {
      label: 'Оборот',
      value: `${formatCurrency(turnoverUdst, Currencies.USDT)} ≈ ${formatCurrency(turnoverRub, Currencies.RUB)}`,
    },
  ]

  return (
    <StatisticsBanner
      title="Статистика"
      titleAction={
        <button className="pb-1 border-b-2 border-primary dark:border-primary-dark font-medium text-primary dark:text-primary-dark hover:opacity-80 transition-opacity">
          Входящие
        </button>
      }
      mobileTitleAction={
        isMobile && onDateChange ? (
          <DatePickerWithRange
            variant="outline"
            onDateChange={onDateChange}
            defaultValue={dateRange}
          />
        ) : undefined
      }
      items={items}
      itemsPerRow={3}
    />
  )
}
